// =====================================================
// EPHEMERIDES - Efemérides del día
// =====================================================
// Inserta una efeméride elegante antes de "Negocios Destacados"

(function() {
  'use strict';

  const API_BASE = window.apiConfig?.baseURL || (function(){ try { return window.location.hostname.match(/localhost|127\.0\.0\.1/) ? `${location.protocol}//${location.hostname}:3000/api/v1` : `${location.origin}/api/v1`; } catch { return `${location.protocol}//${location.hostname}/api/v1`; } })();
  
  // Configuración del sitio (puedes ajustar según tu contexto)
  const SITE_CONFIG = {
    city: null,        // Se puede obtener del contexto si existe
    country: 'CO',     // País por defecto
    language: 'es'     // Idioma por defecto
  };

  /**
   * Detecta ciudad/país del contexto actual si está disponible
   */
  function detectLocation() {
    // Intentar obtener de algún estado global si existe
    const city = window.siteLocation?.city || SITE_CONFIG.city;
    const country = window.siteLocation?.country || SITE_CONFIG.country;
    
    return { city, country };
  }

  /**
   * Crea el skeleton de carga
   */
  function createSkeleton() {
    const section = document.createElement('section');
    section.className = 'ephemerides-section';
    section.replaceChildren();
    const container = document.createElement('div');
    container.className = 'ephemerides-container';
    const skeleton = document.createElement('div');
    skeleton.className = 'ephemerides-skeleton';
    ['short', 'long', 'medium', 'short'].forEach((size) => {
      const line = document.createElement('div');
      line.className = `skeleton-line ${size}`;
      skeleton.appendChild(line);
    });
    container.appendChild(skeleton);
    section.appendChild(container);
    return section;
  }

  /**
   * Renderiza la efeméride
   */
  function renderEphemeride(data) {
    const section = document.createElement('section');
    section.className = 'ephemerides-section';
    
    const scopeLabels = {
      'world': 'Mundial',
      'country': 'Nacional', 
      'city': 'Local'
    };
    
    const scopeLabel = scopeLabels[data.scope] || 'Efeméride';
    
    section.replaceChildren();
    const container = document.createElement('div');
    container.className = 'ephemerides-container';

    const card = document.createElement('div');
    card.className = 'ephemerides-card';

    const iconWrap = document.createElement('div');
    iconWrap.className = 'ephemerides-icon';

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'ephemerides-icon-svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    const p1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p1.setAttribute('class', 'icon-star-outer');
    p1.setAttribute('d', 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z');
    p1.setAttribute('stroke', 'currentColor');
    p1.setAttribute('stroke-width', '1.5');
    p1.setAttribute('fill', 'none');

    const p2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p2.setAttribute('class', 'icon-star-inner');
    p2.setAttribute('d', 'M12 6l1.5 3L16 9.5l-2.5 2.5L14 15l-2-1-2 1 .5-3L8 9.5l2.5-.5L12 6z');
    p2.setAttribute('fill', 'currentColor');
    p2.setAttribute('opacity', '0.3');

    const c1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c1.setAttribute('class', 'icon-sparkle-1');
    c1.setAttribute('cx', '6');
    c1.setAttribute('cy', '6');
    c1.setAttribute('r', '1');
    c1.setAttribute('fill', 'currentColor');

    const c2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c2.setAttribute('class', 'icon-sparkle-2');
    c2.setAttribute('cx', '18');
    c2.setAttribute('cy', '6');
    c2.setAttribute('r', '1');
    c2.setAttribute('fill', 'currentColor');

    const c3 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c3.setAttribute('class', 'icon-sparkle-3');
    c3.setAttribute('cx', '6');
    c3.setAttribute('cy', '18');
    c3.setAttribute('r', '1');
    c3.setAttribute('fill', 'currentColor');

    const c4 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c4.setAttribute('class', 'icon-sparkle-4');
    c4.setAttribute('cx', '18');
    c4.setAttribute('cy', '18');
    c4.setAttribute('r', '1');
    c4.setAttribute('fill', 'currentColor');

    svg.appendChild(p1);
    svg.appendChild(p2);
    svg.appendChild(c1);
    svg.appendChild(c2);
    svg.appendChild(c3);
    svg.appendChild(c4);
    iconWrap.appendChild(svg);

    const quote = document.createElement('blockquote');
    quote.className = 'ephemerides-quote';
    quote.textContent = (data && data.quote != null) ? String(data.quote) : '';

    const meta = document.createElement('div');
    meta.className = 'ephemerides-meta';
    const scope = document.createElement('span');
    scope.className = 'ephemerides-scope';
    scope.textContent = scopeLabel;
    meta.appendChild(scope);
    if (data && data.source) {
      const cite = document.createElement('cite');
      cite.className = 'ephemerides-source';
      cite.textContent = String(data.source);
      meta.appendChild(cite);
    }

    card.appendChild(iconWrap);
    card.appendChild(quote);
    card.appendChild(meta);
    container.appendChild(card);
    section.appendChild(container);
    
    return section;
  }

  /**
   * Encuentra el punto de inserción (después de categorías populares)
   */
  function findInsertionPoint() {
    // PRIORIDAD 1: Después de "Productos Destacados Premium"
    const premiumSpotlight = document.querySelector('section.premium-spotlight');
    if (premiumSpotlight) {
      return { type: 'after', element: premiumSpotlight };
    }
    
    // PRIORIDAD 2: Antes de "Descubre los negocios Premium"
    const featuredBusinesses = document.querySelector('section.featured-businesses-section');
    if (featuredBusinesses) {
      return { type: 'before', element: featuredBusinesses };
    }
    
    // PRIORIDAD 3: Antes de la sección de testimonios
    const testimonials = document.querySelector('.testimonials');
    if (testimonials) {
      return { type: 'before', element: testimonials };
    }
    
    // PRIORIDAD 4: Después de categorías populares
    const categories = document.querySelector('section.categories-populares');
    if (categories) {
      return { type: 'after', element: categories };
    }
    
    // Último fallback: antes de #featured-businesses
    const businessContainer = document.getElementById('featured-businesses');
    if (!businessContainer) {
      console.warn('[Ephemerides] No se encontró el contenedor #featured-businesses.');
      return null;
    }

    // Subimos al elemento <section> padre. Este es el verdadero punto de inserción.
    const sectionContainer = businessContainer.closest('section');
    if (!sectionContainer) {
        console.warn('[Ephemerides] No se encontró la <section> padre de #featured-businesses. Usando el contenedor como fallback.');
        return { type: 'before', element: businessContainer };
    }

    console.log('[Ephemerides] Usando fallback: antes de featured-businesses');
    return { type: 'before', element: sectionContainer };
  }

  /**
   * Inserta la sección en el punto especificado
   */
  function insertSection(ephemeridesSection, insertionInfo) {
    if (!insertionInfo) {
      console.warn('[Ephemerides] No se proporcionó información de inserción');
      return false;
    }
    
    const { type, element } = insertionInfo;
    
    if (!element || !element.parentElement) {
      console.warn('[Ephemerides] Elemento de inserción inválido');
      return false;
    }
    
    try {
      if (type === 'after') {
        // Insertar después del elemento
        if (element.nextSibling) {
          element.parentElement.insertBefore(ephemeridesSection, element.nextSibling);
        } else {
          element.parentElement.appendChild(ephemeridesSection);
        }
      } else if (type === 'before') {
        // Insertar antes del elemento
        element.parentElement.insertBefore(ephemeridesSection, element);
      }
      
      return true;
    } catch (error) {
      console.error('[Ephemerides] Error al insertar sección:', error);
      return false;
    }
  }

  /**
   * Espera a que premium-spotlight esté en el DOM
   */
  function waitForPremiumSpotlight() {
    return new Promise((resolve) => {
      // Escuchar el evento custom
      window.addEventListener('premium-spotlight-loaded', () => {
        // Pequeño delay para asegurar que el DOM esté actualizado
        setTimeout(() => resolve(), 200);
      }, { once: true });
      
      // Timeout de seguridad (10 segundos)
      setTimeout(() => {
        resolve();
      }, 10000);
    });
  }

  /**
   * Carga y muestra la efeméride del día
   */
  async function loadEphemeride() {
    // Esperar a que premium-spotlight se cargue primero
    await waitForPremiumSpotlight();
    
    const insertionPoint = findInsertionPoint();
    if (!insertionPoint) {
      console.warn('[Ephemerides] No se encontró punto de inserción');
      return;
    }

    // Mostrar skeleton
    const skeleton = createSkeleton();
    if (!insertSection(skeleton, insertionPoint)) {
      console.warn('[Ephemerides] No se pudo insertar skeleton');
      return;
    }

    (async () => {
        try {
          const { city, country } = detectLocation();
          const params = new URLSearchParams();
          
          if (city) params.set('city', city);
          if (country) params.set('country', country);
          params.set('lang', SITE_CONFIG.language);

          const url = `${API_BASE}/public/ephemerides/today?${params.toString()}`;
          
          const response = await fetch(url, {
            method: 'GET',
            credentials: 'omit', // No necesitamos cookies para endpoint público
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const result = await response.json();
          
          if (result.success && result.data) {
            // Reemplazar skeleton con efeméride real
            const ephemeridesSection = renderEphemeride(result.data);
            skeleton.replaceWith(ephemeridesSection);
          } else {
            // No hay efeméride, remover skeleton silenciosamente
            skeleton.remove();
          }

        } catch (error) {
          console.warn('[Ephemerides] Error cargando efeméride:', error);
          // Remover skeleton en caso de error
          skeleton.remove();
        }
      })();
  }

  /**
   * Inicializar cuando el DOM esté listo
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadEphemeride);
    } else {
      loadEphemeride();
    }
  }

  // Auto-inicializar
  init();

  // Exponer función para uso manual si es necesario
  window.EphemeridesLoader = {
    load: loadEphemeride,
    detectLocation: detectLocation
  };

})();
// Force update 08/17/2025 17:03:17
